import {
  SET_AI_HEATMAP_DATA,
  HEATMAP_STATE,
} from '../constants/ActionTypes.js';

export const defaultState = {
  heatmaps: [],
};

export const heatmaps = (state = defaultState, action) => {
  switch (action.type) {
    case SET_AI_HEATMAP_DATA: {
      let newHeatmaps = [];
      if (action.data.type === 'clear') {
        newHeatmaps = [];
      } else {
        newHeatmaps = state.heatmaps.filter(
          ht =>
            ht.objectUid !== action.data.objectUid ||
            ht.type !== action.data.type
        );
        newHeatmaps.push(action.data);
      }

      return { heatmaps: newHeatmaps };
    }

    case HEATMAP_STATE: {
      return { heatmaps: [] };
    }

    default:
      return state;
  }
};
